<template>
  <div class="god_page_container">
    <div class="page-title-row">
      <h2>Facturación</h2>
    </div>

    <div id="selector_container">
      <div class="expiration-date-container">
        <input
          type="month"
          v-model="month"
          class="input_200" />
      </div>

      <div class="radio-pill-group">
        <label class="radio-pill" :class="{ 'is-selected': modo === '0' }">
          <input
            type="radio"
            value="0"
            v-model="modo"
          />
          <span>Facturación Click And Plan</span>
        </label>
        <label class="radio-pill" :class="{ 'is-selected': modo === '1' }">
          <input
            type="radio"
            value="1"
            v-model="modo"
          />
          <span>Facturas de liquidación</span>
        </label>
      </div>

      <input type="text" placeholder="Filtrar por empresa..." v-model="filterText" class="input_200"/>

      <button @click="getInvoices()" class="main_button" style="min-width: 140px;">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
        Buscar
      </button>
    </div>
    <div class="table-container">
      <table v-if="modo === '0'">
        <thead>
          <tr>
              <th class="big">Empresa</th>
              <th class="small">Num compras</th>
              <th class="small">Importe vendido</th>
              <th class="small">GGE</th>
              <th class="small">GGU</th>
          </tr>
        </thead>
        <tfoot v-if="clickAndPlanInfo.length > 0">
          <tr>
              <th class="big"></th>
              <th class="small"></th>
              <th class="small">{{ totalCPImporte }}€</th>
              <th class="small">{{ totalCPGGE }}€</th>
              <th class="small">{{ totalCPGGU }}€</th>
            </tr>
        </tfoot>

        <tbody>
          <tr 
            v-for="(item, index) in clickAndPlanInfo
              .filter(invoice => !filterText ||
                (invoice.empresa && invoice.empresa.toLowerCase().includes(filterText.toLowerCase())))"
            :key="item.id_empresa"
            :class="index % 2 === 0 ? 'bg-gray-100' : 'bg-white'"
          >
            <td>{{ item.empresa }}</td>
            <td>{{ item.num_compras }}</td>
            <td>{{ (Number(item.importe_comprado) || 0).toFixed(2) }}€</td>
            <td>{{ (Number(item.gge) || 0).toFixed(2)}}€</td>
            <td>{{ (Number(item.ggu) || 0).toFixed(2)}}€</td>
          </tr>
        </tbody>
      </table>

      <table v-if="modo === '1'">
        <thead>
          <tr>
              <th class="big">Empresa</th>
              <th class="small">Mes</th>
              <th class="small">Total</th>
              <th class="small">GGE</th>
              <th class="small">Acciones</th>
          </tr>
        </thead>
        <tfoot v-if="invoices.length > 0">
          <tr>
              <th class="big"></th>
              <th class="small"></th>
              <th class="small">{{ totalImporte }}€</th>
              <th class="small">{{ totalGGE }}€ (s. IVA {{ totalGGESIVA }}€)</th>
              <th class="small">
                <img class="action_icon tinted_white" src="@/assets/images/ic_action_download.png" @click="onDownloadAllClicked(item)"/>
              </th>
            </tr>
        </tfoot>
        <tbody>
          <tr 
            v-for="(item, index) in invoices
              .filter(invoice => !filterText ||
                (invoice.nombre_empresa && invoice.nombre_empresa.toLowerCase().includes(filterText.toLowerCase())))"
            :key="item.id_empresa"
            :class="index % 2 === 0 ? 'bg-gray-100' : 'bg-white'"
          >
            <td>{{ item.nombre_empresa }}</td>
            <td>{{ item.fecha }}</td>
            <td>{{ item.total }}€</td>
            <td>{{ item.gge }}€ (s. IVA {{ (item.gge / 1.21).toFixed(2) }}€)</td>
            <td>
              <img class="action_icon" src="@/assets/images/ic_action_download.png" @click="onDownloadClicked(item)"/>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="invoices.length === 0 && modo === '1'" style="display: flex; justify-content: center; margin-top: 1rem;">
      <label>No hay ninguna factura para el mes seleccionado</label>
    </div>
    <div v-if="clickAndPlanInfo.length === 0 && modo === '0'" style="display: flex; justify-content: center; margin-top: 1rem;">
      <label>No hay información para el mes seleccionado</label>
    </div>

    <ErrorPopup :errorMessage="error" />

  </div>
</template>

<script setup>
  import { computed, ref, nextTick, watch } from 'vue'
  import { useLoadingStore } from "@/stores/loadingStore";
  import { useRouter, useRoute } from 'vue-router';
  import { refreshToken } from "@/services/authService";
  import ErrorPopup from "@/components/common/ErrorPopup.vue";
  import JSZip from "jszip";
  import { saveAs } from "file-saver";

  const error = ref(null);
  const invoices = ref([]);
  const clickAndPlanInfo = ref([]);
  const loadingStore = useLoadingStore();
  const router = useRouter();
  const route = useRoute();
  const month = ref(route.query.month || '');
  const modo = ref(route.query.modo || '0');
  const filterText = ref(route.query.filterText || "");

  watch([month, modo, filterText], () => {
    router.replace({
      query: {
        ...route.query,
        month: month.value,
        modo: modo.value,
        filterText: filterText.value
      }
    });
  });

  const totalImporte = computed(() =>
    invoices.value
      .filter(invoice => !filterText.value || (invoice.nombre_empresa && invoice.nombre_empresa.toLowerCase().includes(filterText.value.toLowerCase())))
      .reduce((sum, item) => sum + Number(item.total || 0), 0)
      .toFixed(2)
  )

  const totalGGE = computed(() =>
    invoices.value
      .filter(invoice => !filterText.value || (invoice.nombre_empresa && invoice.nombre_empresa.toLowerCase().includes(filterText.value.toLowerCase())))
      .reduce((sum, item) => sum + Number(item.gge || 0), 0)
      .toFixed(2)
  )

  const totalGGESIVA = computed(() =>
    invoices.value
      .filter(invoice => !filterText.value || (invoice.nombre_empresa && invoice.nombre_empresa.toLowerCase().includes(filterText.value.toLowerCase())))
      .reduce((sum, item) => sum + Number(item.gge || 0) / 1.21, 0)
      .toFixed(2)
  )

  const totalCPImporte = computed(() =>
    clickAndPlanInfo.value
      .filter(invoice => !filterText.value || (invoice.empresa && invoice.empresa.toLowerCase().includes(filterText.value.toLowerCase())))
      .reduce((sum, item) => sum + Number(item.importe_comprado || 0), 0)
      .toFixed(2)
  )

  const totalCPGGE = computed(() =>
    clickAndPlanInfo.value
      .filter(invoice => !filterText.value || (invoice.empresa && invoice.empresa.toLowerCase().includes(filterText.value.toLowerCase())))
      .reduce((sum, item) => sum + Number(item.gge || 0), 0)
      .toFixed(2)
  )

  const totalCPGGU = computed(() =>
    clickAndPlanInfo.value
      .filter(invoice => !filterText.value || (invoice.empresa && invoice.empresa.toLowerCase().includes(filterText.value.toLowerCase())))
      .reduce((sum, item) => sum + Number(item.ggu || 0) / 1.21, 0)
      .toFixed(2)
  )

  const getInvoices = async () => {
    if (month.value === '') {
      showError("Por favor, selecciona un mes.");
      return;
    }
    if (modo.value === '0') {
      getClickAndPlanInfo();
      return;
    }

    loadingStore.setLoading(true);
    error.value = null;

    try {
      let response = await getInvoicesInAPI();

      if (response.status === 401) {
        const refreshed = await refreshToken();
        if (refreshed) {
          response = await getInvoicesInAPI();
        } else {
          loadingStore.setLoading(false);
          localStorage.removeItem('user_id');
          localStorage.removeItem('token');
          router.push('/');
          return;
        }
      }

      if (!response.ok) {
        showError("Se ha producido un error descargando las facturas.");
        return;
      }

      const data = await response.json();

      if (data.errors) {
        error.value = data.message;
        invoices.value = [];
      } else {
        error.value = null;
        invoices.value = data.invoices;
      }
    } catch (exception) {
      error.value = exception.message;
    } finally {
      loadingStore.setLoading(false);
    }
  };

  async function getInvoicesInAPI() {
    return await fetch(process.env.VUE_APP_API_URL+"api/god/invoices/get_by_month?user_id="+localStorage.getItem('user_id')+"&month="+month.value, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "vgod": process.env.VUE_APP_API_VGOD,
          "cp-token": process.env.VUE_APP_API_CP_TOKEN,
          "Authorization": "Bearer " + localStorage.getItem('token')
        },
      });
  }

  const getClickAndPlanInfo = async () => {
    loadingStore.setLoading(true);
    error.value = null;

    try {
      let response = await getClickAndPlanInfoInAPI();

      if (response.status === 401) {
        const refreshed = await refreshToken();
        if (refreshed) {
          response = await getClickAndPlanInfoInAPI();
        } else {
          loadingStore.setLoading(false);
          localStorage.removeItem('user_id');
          localStorage.removeItem('token');
          router.push('/');
          return;
        }
      }

      if (!response.ok) {
        showError("Se ha producido un error descargando la información de facturación.");
        return;
      }

      const data = await response.json();

      if (data.errors) {
        error.value = data.message;
        clickAndPlanInfo.value = [];
      } else {
        error.value = null;
        clickAndPlanInfo.value = data.invoices;
      }
    } catch (exception) {
      error.value = exception.message;
    } finally {
      loadingStore.setLoading(false);
    }
  };

    async function getClickAndPlanInfoInAPI() {
    return await fetch(process.env.VUE_APP_API_URL+"api/god/invoices/get_click_and_plan_info?user_id="+localStorage.getItem('user_id')+"&month="+month.value, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "vgod": process.env.VUE_APP_API_VGOD,
          "cp-token": process.env.VUE_APP_API_CP_TOKEN,
          "Authorization": "Bearer " + localStorage.getItem('token')
        },
      });
  }

  const showError = async (message) => {
    error.value = null;
    await nextTick();
    error.value = message;
  };

  const onDownloadAllClicked = async () => {
    loadingStore.setLoading(true);
    error.value = null;
    const zip = new JSZip();

    const pdfPromises = invoices.value
      .filter(invoice => !filterText.value || (invoice.nombre_empresa && invoice.nombre_empresa.toLowerCase().includes(filterText.value.toLowerCase())))
      .map(async(item) => {
        let response = await getInvoiceInAPI(item);
        const blob = await response.blob();
        zip.file("FL_"+item.id_empresa+".pdf", blob);
      }
    );


    try {
      await Promise.all(pdfPromises);
      const zipBlob = await zip.generateAsync({ type: "blob" });
      saveAs(zipBlob, "FL_"+ month.value.replace(/-/g, "_") + ".zip");
    } catch (err) {
      showError("Error al generar el ZIP");
    } finally {
      loadingStore.setLoading(false);
    }
  }

  const onDownloadClicked = async (item) => {
    loadingStore.setLoading(true);
    error.value = null;

    try {
      let response = await getInvoiceInAPI(item);

      if (response.status === 401) {
        const refreshed = await refreshToken();
        if (refreshed) {
          response = await getInvoiceInAPI(item);
        } else {
          loadingStore.setLoading(false);
          localStorage.removeItem('user_id');
          localStorage.removeItem('token');
          router.push('/');
          return;
        }
      }

      loadingStore.setLoading(false);

      if (!response.ok) {
        error.value = "Se ha producido un error descargando la factura.";
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      window.open(url, '_blank');
    } catch (exception) {
      error.value = exception.message;
    } finally {
      loadingStore.setLoading(false);
    }
  };

  async function getInvoiceInAPI(item) {
    return await fetch(process.env.VUE_APP_API_URL+"api/god/invoices/get?user_id="+localStorage.getItem('user_id')+"&invoice_user_id="+item.id_empresa+"&month="+month.value, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "vgod": process.env.VUE_APP_API_VGOD,
          "cp-token": process.env.VUE_APP_API_CP_TOKEN,
          "Authorization": "Bearer " + localStorage.getItem('token')
        },
      });
  }

</script>

<style scoped>
.radio-pill-group {
  display: flex;
  background: var(--very-clear-gray);
  padding: 4px;
  border-radius: var(--radius-md);
  gap: 4px;
}

.radio-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: var(--radius-sm);
  font-size: 13px;
  font-weight: 600;
  color: var(--text-color-light);
  cursor: pointer;
  transition: all var(--transition-fast);
  user-select: none;
}

.radio-pill input[type="radio"] {
  display: none;
}

.radio-pill.is-selected {
  background: #FFFFFF;
  color: var(--text-color-dark);
  box-shadow: var(--shadow-xs);
}

.big {
  width: 25%;
}

.small {
  width: 15%;
}

.tinted_white {
  filter: brightness(0) invert(1);
}

@media (max-width: 768px) {
  #selector_container > * {
    flex: none !important;
    width: 100%;
  }

  .radio-pill-group {
    flex-direction: column;
  }
}
</style>
